import { Typography } from '@mui/material';
import { node } from 'prop-types';
import React, { memo } from 'react';

const Label = ({ children }) => {
  return (
    <Typography
      variant="body1"
      sx={{
        marginTop: '1.333em',
        marginBottom: '0.467em',
        fontSize: 15,
        fontWeight: 600,
      }}
    >
      {children}
    </Typography>
  );
};

Label.propTypes = {
  children: node.isRequired,
};

export default memo(Label);
